import "./App.css";
import React, { useEffect, useState, useRef } from "react";
import { SearchCircleIcon } from "@heroicons/react/solid";
import IndividualMlo from "./IndividualMlo";
import Spinner from "./Spinner";
import Nav from "./nav/Nav";
import Footer from "./Footer";
import Subheader from "./nav/Subheader";

function App() {
  const searchField = useRef("");

  const [filteredMloData, setFilteredMloData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const [hasSearchedOrNot, setHasSearchedOrNot] = useState(
    "Search for a loan officer"
  );

  const apiCall = async (searchField) => {
    const formData = new FormData();
    formData.append("searchTerm", searchField);

    const response = await fetch(
      "https://othlpps.loanforceinsider.com/api/SignatureUser/Search",
      {
        method: "POST",
        body: formData,
      }
    );

    const data = await response.json();

    return data;
  };

  const formData = new FormData();
  async function getMLOData(searchTerm) {
    setIsLoading(true);
    let results = [];

    if (searchTerm.includes(" ")) {
      const names = searchTerm.split(" ");
      const firstName = names[0];
      const lastName = names.slice(1).join(" ");

      // Send API calls with first and last name
      const dataFirstName = await apiCall(firstName);
      const dataLastName = await apiCall(lastName);
      console.log(dataFirstName);
      console.log(dataLastName);

      // Intersect both datasets to find common entries
      const firstNameIds = new Set(
        dataFirstName.map((mlo) => mlo.LoanForce__NMLS_Number__c)
      );
      results = dataLastName.filter((mlo) =>
        firstNameIds.has(mlo.LoanForce__NMLS_Number__c)
      );
    } else {
      // Send single API call with the full search term
      results = await apiCall(searchTerm);
    }

    console.log(results);
    setFilteredMloData(filterMloData(results));
    console.log(filterMloData(results));
    setIsLoading(false);
    setHasSearchedOrNot("No Loan officers found");
  }

  const filterMloData = (data2) => {
    const filteredMloData = data2.filter((mlo) => {
      return (
        mlo.MLO_Page__c === "True" &&
        mlo.IsActive === "True" &&
        mlo.Brand__c === "OneTrust Home Loans" &&
        !mlo.Email.endsWith(".invalid") &&
        mlo.LoanForce__NMLS_Number__c !== ""
      );
    });

    return filteredMloData;
  };

  function submitForm() {
    formData.append("searchTerm", searchField.current.value);
    if (searchField.current.value === "") {
      setIsError(true);
      setFilteredMloData([]);
      return;
    }
    setIsError(false);
    getMLOData(searchField.current.value);
  }

  useEffect(() => {
    if (filterMloData.length === 0) {
      // console.log(filterMloData.length);
      getMLOData("");
    }
  }, [filterMloData]);

  const items = (
    <div className="grid grid-cols-1 gap-12 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ">
      {filteredMloData.map((item) => (
        <IndividualMlo
          key={item.Email + item.FirstName + item.Phone + item.Street}
          mloData={item}
        />
      ))}
    </div>
  );

  return (
    <div>
      <Subheader className="z-20 " />
      <div>
        <Nav className="" />

        <div className="bg-gray-efftwo">
          <h1 className="text-blue-primary text-4xl text-center py-12 pt-40 font-bold">
            Find a Loan Officer
          </h1>
          <div className="flex justify-center py-12 bg-gray-efftwo items-center">
            <div className="w-3/4 lg:w-1/3 bg-white h-12 rounded-3xl relative ">
              <input
                type="text"
                ref={searchField}
                placeholder="Search"
                onChange={submitForm}
                className="rounded-3xl pl-6 flex-1 w-5/6 h-full h-12 focus:outline-none"
              />
              <button
                type="button"
                onClick={submitForm}
                className="ml-auto inline-flex items-center p-2 shadow-sm text-base font-medium rounded-full text-white bg-green-primary hover:bg-green-primary absolute right-2 top-1"
              >
                <SearchCircleIcon className="h-5 w-5" aria-hidden="true" />
              </button>
              {isError ? (
                <p className="text-left text-red-error ml-6 py-2">
                  Enter text to search
                </p>
              ) : null}
            </div>
          </div>
        </div>
        <div className="bg-gray-efour">
          <div className="flex justify-center py-24 bg-gray-efour">
            {isLoading ? <Spinner /> : <div>{items}</div>}
          </div>
          {filteredMloData == 0 && !isLoading ? (
            <div className="flex justify-center pb-52">
              <div>
                <h2 className="text-xl">{hasSearchedOrNot}</h2>
              </div>
            </div>
          ) : null}
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
